import axios from 'axios';
import { API_BASE_URL } from './api';

export interface Place {
  id: string;
  name: string;
  address: string;
  description: string;
  sportType: string;
  placeType: string;
  lat: number;
  lng: number;
  rating?: number;
  isOpen?: boolean;
  isFree?: boolean;
  isAccessible?: boolean;
}

export interface PlaceSearchParams {
  lat?: number;
  lng?: number;
  radius?: number;
  placeType?: string;
}

/**
 * Fetch places from the API with optional filters
 */
export const fetchPlaces = async (params: PlaceSearchParams = {}): Promise<Place[]> => {
  try {
    const queryParams = new URLSearchParams();

    if (params.lat !== undefined) {
      queryParams.append('lat', params.lat.toString());
    }
    if (params.lng !== undefined) {
      queryParams.append('lng', params.lng.toString());
    }
    if (params.radius !== undefined) {
      queryParams.append('radius', params.radius.toString());
    }
    if (params.placeType) {
      queryParams.append('placeType', params.placeType);
    }

    const url = `${API_BASE_URL}/api/places${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const response = await axios.get<Place[]>(url);

    return response.data;
  } catch (error) {
    console.error('Error fetching places:', error);
    throw error;
  }
};

/**
 * Fetch a single place by ID
 */
export const fetchPlaceById = async (id: string): Promise<Place | null> => {
  try {
    const places = await fetchPlaces();
    return places.find(place => place.id === id) || null;
  } catch (error) {
    console.error('Error fetching place by ID:', error);
    return null;
  }
};